import TronWeb from "tronweb";
export const tronWeb = new TronWeb({
  fullHost: 'https://api.trongrid.io',
    solidityNode: 'https://api.trongrid.io',
    eventServer: 'https://api.trongrid.io',
});

